<template>
  <div class="how-to-order page">
    <div class="bg"></div>
    <div class="page-wrap">
      <div class="inner">
        <div class="get-site fadeInB">
          <h2>How to Order</h2>
          <p>
            We have numerous local and independent businesses who sell, install and support our products all over the globe.
            These companies are highly trained and form our Authorised ICRTouch Partner Network.
          </p>
          <br>
          <p>Please browse our Partners at the link below to find an ICRTouch Authorised Partner that is local to you.</p>
          <div class="buttons ani-wrap">
            <a href="//icrtouch.com/where-to-buy" alt="How to order" target="_blank" class="fadeInB">
              <div class="default-btn">Find a Partner</div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "how"
};
</script>

<style lang="scss" scoped>
.how-to-order {
  position: relative;
  transition: 0.3s ease;
  .bg {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    opacity: 1;
    background: linear-gradient(to left bottom, #f6932d 0%, #ec6005 100%);
    z-index: 2;
    transition: 0.3s ease;
  }
  .page-wrap {
    position: relative;
    height: 100%;
    width: 100%;
    padding:20px;
    overflow-x: hidden;
    z-index: 8;
    .inner {
      display: flex;
      flex-wrap: wrap;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100%;
      margin: auto;
      max-width: 1300px;
      color: #fff;
      .get-site {
        animation-delay: 0.5s;
        margin: 0 0 50px 0;
        h2 {
          font-weight: 400;
          color: #fff;
          margin: 0 0 10px 0;
        }
        p {
          max-width: 600px;
          color: #fff;
        }
        .buttons {
          margin:15px 0 0 0;
        }
      }
    }
  }
}

.how-to-order.page-trans-enter-active {
  .bg {
    opacity: 0;
  }
}

.how-to-order.page.page-trans-leave-active {
  .bg {
    opacity: 0;
  }
  .fadeInB {
    animation: fadeOutB 0.25s ease-out both 1;
    animation-delay: 0s !important;
  }
}

.fadeInB {
  animation: fadeInB 0.25s ease-out both 1;
}
</style>

